import { createApp } from 'vue'
import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import Toaster from "@meforma/vue-toaster";
import App from './App.vue'
import router from './router'
import './assets/theme.css'


const store = createStore({
    plugins: [createPersistedState()],
    state() {
        return {
            user: {},
            token: "",
            loggedIn: false,
        }
    },
    mutations: {
        setAuth(state, token) {
            state.token = token;
            state.loggedIn = true;
        },
        setToken(state, token) {
            state.token = token;
        },
        setUser(state, user) {
            state.user = user || {};
        },
        logout(state) {
            state.loggedIn = false;
            state.user = {};
            state.token = "";
        }
    },
    actions: {
        async science({ state, commit }) {
            if (state.loggedIn) {
              try {
                const response = await fetch(`${process.env.VUE_APP_ENDPOINT}/dashboard/api/v1/science`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': state.token
                    }
                });

                const result = await response.json();
                if (result.status === "success") commit('setUser', result.user);
                else commit('logout');
              } catch (error) {
                console.error('Session validation failed', error);
                commit('logout');
              }
            }
        }
    },
});

router.beforeEach((to) => {
    if (to.meta.requiresAuth && !store.state.loggedIn) return { name: 'Login' };
    if (to.meta.requiresAdmin && Number(store.state.user?.is_admin) !== 1) return { name: 'Dashboard' };
    if ((to.name === 'Login' || to.name === 'Register') && store.state.loggedIn) return { name: 'Dashboard' };
    return true;
});

createApp(App).use(router).use(store).use(Toaster).mount('#app');
